import { useRef, useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import register from 'src/assets/images/register_new.svg'
import TextField from '@mui/material/TextField'
import { useHistory } from 'react-router-dom'
import { Button, makeStyles } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import Modal from 'src/components/common/Modal'
import { merged, registeruserinfo, showNotificationMessage } from 'src/actions'
import { getToken, registerUser } from 'src/services/individualService'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import LoadingModal from 'src/components/common/LoadingModal'
import {
  ERROR_MESSAE,
  REGISTRATION_NOTIFICATION,
} from 'src/utils/constants/Registration'

const Registration = () => {
  const classes = useStyles()
  let history = useHistory()
  const dispatch = useDispatch()
  const [modalOpen, setModalClose] = useState(false)
  const [showMessage, setShowMessage] = useState(false)
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [userDetails, setUserDetails] = useState({
    fullName: '',
    mobileNumber: '',
    emailId: '',
    lastName: '',
  })

  const reRef = useRef()
  const purchaseCancelHandler = () => {
    setModalClose(false)
    setMessage('')
  }
  const handleSubmit = async (e) => {
    setMessage('')
    setLoading(true)
    e?.stopPropagation()
    e?.preventDefault()
    const token = await reRef.current.executeAsync()
    reRef.current.reset()
    const res = await fetchToken()
    const resp = await registerUser(
      userDetails?.fullName,
      userDetails?.emailId,
      userDetails?.mobileNumber,
      userDetails?.mobileNumber,
      token,
      res,
      userDetails?.lastName,
      false
    )
    try {
      if (!resp?.res?.data?.success) {
        setLoading(false)
        if (resp?.res?.data?.code === '002') {
          setMessage(resp?.res?.data?.message)
          dispatch(registeruserinfo(resp?.res?.data?.userData))
          setModalClose(true)
        } else {
          setMessage(resp?.res?.data?.message)
          setShowMessage(true)
        }
      } else {
        setLoading(false)
        dispatch(registeruserinfo(resp?.res?.data?.userData))
        history.push('/individual/dashboard/register/otp')
      }
    } catch (err) {
      setLoading(false)
      let num = resp?.response?.data?.status
      if (400 <= num && num <= 499) {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: REGISTRATION_NOTIFICATION?.TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: REGISTRATION_NOTIFICATION?.PLEASE_RELOAD_TRY_AGAIN,
          })
        )
      }
    }
  }

  const fetchToken = async () => {
    const response = await getToken()
    if (response?.res?.status !== 200) {
      setMessage(ERROR_MESSAE)
      setModalClose(true)
    }
    return response?.res?.data?.access_token
  }

  const mergeConfirm = async () => {
    setLoading(true)
    dispatch(merged())
    setModalClose(false)
    const token = await reRef.current.executeAsync()
    reRef.current.reset()
    const res = await fetchToken()
    const resp = await registerUser(
      userDetails?.fullName,
      userDetails?.emailId,
      userDetails?.mobileNumber,
      userDetails?.mobileNumber,
      token,
      res,
      userDetails?.lastName,
      true
    )
    if (!resp?.res?.data?.success) {
      setLoading(false)
      if (resp?.res?.data?.code === '002') {
        setMessage(resp?.res?.data?.message)

        dispatch(registeruserinfo(resp?.res?.data?.userData))
        setModalClose(true)
      } else {
        setMessage(resp?.res?.data?.message)

        setShowMessage(true)
      }
    } else {
      setLoading(false)
      dispatch(registeruserinfo(resp?.res?.data?.userData))
      history.push('/individual/dashboard/register/otp')
    }

    history.push('/individual/dashboard/register/otp')
  }

  const mergeReject = () => {
    setUserDetails({
      fullName: '',
      mobileNumber: '',
      emailId: '',
      lastName: '',
    })
    dispatch(registeruserinfo({}))
    setModalClose(false)
  }

  const handleFormChange = (event) => {
    setUserDetails({
      ...userDetails,
      [event.target.name]: event?.target?.value,
    })
  }

  return (
    <>
      <LoadingModal loading={loading} />
      {modalOpen ? (
        <Modal
          ordered={modalOpen}
          width={'50%'}
          left={'25%'}
          top={'15%'}
          modelClosed={purchaseCancelHandler}
        >
          <p className={classes.mergeMessage}>{message}</p>
          <div className={classes.mergeButtonsContainer}>
            <Button className={classes.modalButton} onClick={mergeConfirm}>
              Merge
            </Button>
            <Button className={classes.modalButton} onClick={mergeReject}>
              Reject
            </Button>
          </div>
        </Modal>
      ) : null}

      <form id='registerForm' onSubmit={handleSubmit}>
        <div className={'flex'}>
          <img
            src={register}
            className={classes.registrationImage}
            alt={'registerImg'}
          />
          <p className={classes.registrationText}>Register</p>
        </div>
        <div className={classes.formControlContainer}>
          <TextField
            name='fullName'
            id='name'
            type='name'
            placeholder='Full Name'
            value={userDetails?.fullName}
            onChange={handleFormChange}
            required
            className={`${classes.customTextField} ${classes.fullNameField}`}
            inputProps={{ pattern: '[A-Za-z0-9 ]+' }}
          />
        </div>

        <div className={classes.formControlContainer}>
          <TextField
            name='mobileNumber'
            type='number'
            id='mobile'
            placeholder='987-654-3211'
            value={userDetails?.mobileNumber}
            onChange={(event) => {
              event.target.value = Math.max(0, parseInt(event?.target?.value))
                ?.toString()
                ?.slice(0, 10)
              handleFormChange(event)
            }}
            required
            className={`${classes.customTextField} ${classes.fullNameField}`}
            inputProps={{ pattern: '[1-9]{1}[0-9]{9}' }}
          />
        </div>

        <div className={classes.formControlContainer}>
          <TextField
            name='emailId'
            type='email'
            id='email'
            placeholder='Email (Optional)'
            value={userDetails?.emailId}
            onChange={handleFormChange}
            className={`${classes.customTextField} ${classes.fullNameField}`}
            inputProps={{ pattern: '^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$' }}
          />
        </div>

        {showMessage ? (
          <div className={classes.messageContainer}>{message}</div>
        ) : null}

        <div className={classes.captchaContainer}>
          <ReCAPTCHA
            sitekey='6LfjGmcdAAAAAJYlclS6Cm8v48CFPj0oPRLx1tJh'
            ref={reRef}
            size='invisible'
          />
        </div>
        <div className={classes.proceedContainer}>
          <button className={classes.proceedButton}>Proceed</button>
        </div>
        <div className={classes.footerContainer}>
          <p className={classes.footerText}>
            &copy; 2022 Copyrights reserved by Trovity.
          </p>
        </div>
      </form>
    </>
  )
}

export default Registration

const useStyles = makeStyles({
  customTextField: {
    '& input::placeholder': {
      fontSize: '12px',
    },
  },
  fullNameField: {
    '& .MuiInputBase-input': {
      padding: '8px 50px 8px 10px',
    },
    '& .MuiInputBase-root': {
      borderRadius: '50px',
    },
  },
  proceedButton: {
    textTransform: 'unset',
    backgroundColor: '#B92250',
    color: 'white',
    fontSize: '16px',
    padding: '10px 20px 10px 20px!important',
    borderRadius: '50px',
    fontWeight: 'bold',
    border: 'none',
    cursor: 'pointer',
  },
  modalButton: {
    borderRadius: '50px',
    textTransform: 'unset',
    cursor: 'pointer',
    backgroundColor: 'rgba(255, 178, 42, 1)',
    color: 'white',
    width: '15%',
    marginRight: '5%',
  },
  formControlContainer: {
    margin: '15px auto 5px auto',
    textAlign: 'center',
  },
  registrationImage: {
    margin: '10% 0% auto auto',
    textAlign: 'center',
  },
  registrationText: {
    padding: '7px',
    fontSize: '18px',
    margin: '10% auto auto 0%',
    color: 'rgba(0, 0, 0, 1)',
    textAlign: 'center',
  },
  mergeMessage: {
    marginLeft: '5%',
    fontSize: '19px',
  },
  mergeButtonsContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '2%',
  },
  messageContainer: {
    margin: '15px auto 5px auto',
    textAlign: 'center',
    color: 'red',
    width: '57%',
    fontSize: '15px',
  },
  captchaContainer: {
    marginLeft: '50px',
  },
  proceedContainer: {
    margin: '25px auto 5px auto',
    textAlign: 'center',
  },
  footerContainer: {
    margin: '15% auto auto auto',
    textAlign: 'center',
  },
  footerText: {
    fontSize: '9px',
    color: 'rgba(17, 47, 60, 0.6)',
  },
  modalRoot: {
    width: '50% !important',
  },
})
